<template>
  <q-input
    clearable
    v-model="searchText"
    :label="label"
    class="inputMetadataValue"
    v-if="selection != 'report_date_begin' && selection != 'report_date_end' && dropdownOptions == null"
    style="width: 250px"
  />
  <q-select
    v-model="searchText"
    bottom-slots
    clearable
    use-input
    hide-selected
    fill-input
    input-debounce="0"
    :options="dropdownOptions.value"
    @filter="dropdownFilter"
    :label="label"
    class="inputMetadataValue"
    v-if="dropdownOptions != null"
    style="width: 250px"
  >
    <template v-slot:hint>
      <a v-if="selection == 'location_id'" @click="CommonHelper.openURLToNewTab('./Historical School Names for Assets List.pdf')" href="./Historical School Names for Assets List.pdf">School Name History</a>
    </template>
  </q-select>
  <q-input
    clearable
    v-model="searchText"
    :label="label"
    class="inputMetadataValue"
    v-if="selection == 'report_date_begin' || selection == 'report_date_end'"
    style="width: 250px"
    mask="##-##-####"
    hint="MM-DD-YYYY"
    :rules="[(val) => val === null || val === '' || CommonHelper.isValidDate(val)]"
  >
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy transition-show="scale" transition-hide="scale">
          <q-date v-model="searchText" mask="MM-DD-YYYY" minimal>
            <div class="row justify-end">
              <q-btn v-close-popup label="Close" color="primary" flat />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>
import { computed, watch } from "vue";
import CommonHelper from "../helper/CommonHelper.js";

export default {
  name: "AdvancedSearchInput",
  props: {
    label: String,
    selection: String,
    searchTextValue: String,
    index: Number
  },
  emits: ["setSearchText"],
  setup(props, { emit }) {
    const searchText = computed({
      get() {
        if (props.selection === "report_date_begin" || props.selection === "report_date_end") {
          if (CommonHelper.isValidDate(props.searchTextValue)) {
            return props.searchTextValue;
          } else {
            return "";
          }
        } else {
          return props.searchTextValue;
        }
      },
      set(newSearchText) {
        emit("setSearchText", props.index, newSearchText);
      }
    });

    const dropdownOptions = computed(() => {
      let returnValue = null;

      switch(props.selection) {
        case "action_category":
          returnValue = CommonHelper.actionCategoryOptions;
          break;
        case "company_name":
          returnValue = CommonHelper.companyNameOptions;
          break;
        case "document_category":
          returnValue = CommonHelper.documentCategoryOptions;
          break;
        case "file_type":
          returnValue = CommonHelper.fileTypeOptions;
          break;
        case "island":
          returnValue = CommonHelper.islandOptions;
          break;
        case "location_id":
          returnValue = CommonHelper.schoolOptions;
          break;
        case "service_contract_type":
          returnValue = CommonHelper.serviceContractTypeOptions;
          break;
      }

      return returnValue;
    });

    const dropdownFilter = computed(() => {
      let returnValue = null;

      switch(props.selection) {
        case "action_category":
          returnValue = CommonHelper.filterActionCategory;
          break;
        case "company_name":
          returnValue = CommonHelper.filterCompanyName;
          break;
        case "document_category":
          returnValue = CommonHelper.filterDocumentCategory;
          break;
        case "file_type":
          returnValue = CommonHelper.filterFileType;
          break;
        case "island":
          returnValue = CommonHelper.filterIsland;
          break;
        case "location_id":
          returnValue = CommonHelper.filterSchool;
          break;
        case "service_contract_type":
          returnValue = CommonHelper.filterServiceContractType;
          break;
      }

      return returnValue;
    });

    watch(dropdownOptions, () => {
      checkSearchText();
    });

    watch(
      () => CommonHelper.selectedSearchScopeOptions.value,
      () => {
        if (props.selection === "file_type") {
          checkSearchText();
        }
      },
      { deep: true, immediate: true }
    );

    function checkSearchText() {
      if (dropdownOptions.value === null || !dropdownOptions.value.value.includes(searchText.value)) {
        emit("setSearchText", props.index, null);
      }
    }

    return {
      //variable properties
      searchText,
      dropdownOptions,
      dropdownFilter,

      //helpers
      CommonHelper
    };
  },
};
</script>

<style scoped>
.q-field--with-bottom {
  padding-bottom: 0px !important;
}
</style>